import { TenantDetailsState } from './';

interface GetDetailsIsChangedProps {
  current: Omit<TenantDetailsState, 'managementPolicy'>;
  initial: Omit<TenantDetailsState, 'managementPolicy'>;
}

export const getDetailsIsChanged = ({
  current,
  initial,
}: GetDetailsIsChangedProps): boolean => {
  if (current.name !== initial.name) {
    return true;
  }

  if (current.organization?.name !== initial.organization?.name) {
    return true;
  }

  if (
    current.organization?.customerNumber !==
    initial.organization?.customerNumber
  ) {
    return true;
  }

  if (current.managers.length !== initial.managers.length) {
    return true;
  }

  if (
    initial.managers.some(
      (init) => !current.managers.find((curr) => curr.id === init.id),
    )
  ) {
    return true;
  }

  return false;
};
